module.exports = __webpack_public_path__ + "files/1bc49741e95ca9db788ec69e1d9a2d1a.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/generic.png
// module id = 310
// module chunks = 60